import { gql } from "@apollo/client";

export const FETCH_SHIPMENT_LIST = gql`
  query FETCH_SHIPMENT_LIST(
    $latestStatusIn: [String]
    $options: CommonOptionsInput
  ) {
    shipments(latestStatusIn: $latestStatusIn, options: $options) {
      results {
        id
        isEffective
        note
        status
        missingReport
        shippingTerm
        latestStatus
        latestEtd
        latestEta
        requestCargoReadyDate
        created
        invoiceNumber
        shipContainer
        po
        creator {
          id
          email
        }
        customer {
          id
          name
        }
        deletedAt
      }
      total
    }
  }
`;
